import React from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    useMediaQuery,
    useTheme
} from '@mui/material';
import PropTypes from 'prop-types';

const ConfirmRemoveDialog = ({handleClose, handleConfirm, open, relatedComponents = []}) => {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const hasRelated = relatedComponents.length > 0;

    return (
        <Dialog
            fullScreen={fullScreen}
            open={open}
            onClose={handleClose}>
            <DialogTitle>
                {hasRelated
                    ? 'Confirm that you want to remove this component'
                    : 'Remove this component?'}
            </DialogTitle>
            <DialogContent>
                {hasRelated
                    ? (
                        <>
                            <DialogContentText pb={1}>
                                This component is associated with display conditions:
                            </DialogContentText>
                            {relatedComponents.map(c =>
                                <DialogContentText pb={1} key={c.id ?? `${c.label}-${c.description}`}>
                                    {`${c.label} - ${c.description}`}
                                </DialogContentText>
                            )}
                            <DialogContentText>
                                Removing this component will also eliminate all associated relationships.
                            </DialogContentText>
                        </>
                    )
                    : (
                        <DialogContentText>
                            Are you sure you want to remove this component?
                        </DialogContentText>
                    )}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>
                    Cancel
                </Button>
                <Button onClick={handleConfirm} autoFocus>
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>);
};

ConfirmRemoveDialog.propTypes = {
    handleClose: PropTypes.func.isRequired,
    handleConfirm: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    relatedComponents: PropTypes.array
};

export default ConfirmRemoveDialog;